<template>
  <div v-show="isVisible">
    <alert-window ref="alertWindow"></alert-window>
    <div class="title">Описание услуги:</div>
    <div class="dop-info">
      <div>
        <div class="fieldset">
          <label class="fieldset-title">Время прибытия</label>
          <fieldset>
            <input type="text" class="time" placeholder="hh:mm" v-mask="'##:##'" v-model="time">
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Категория</label>
          <fieldset>
            <select v-if="isNew" v-model="newTruckingService.category" @change="onCategoryChange">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="category in truckingCategories" :value="category">
                {{ category.name }}
              </option>
            </select>
            <select v-else v-model="truckingService.category" @change="onCategoryChange">
              <option disabled :value="null">-- Выбрать --</option>
              <option v-for="category in truckingCategories" :value="category">
                {{ category.name }}
              </option>
            </select>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title long-title">Клиентское время<br> (прогноз)</label>
          <fieldset :class="[ { 'fieldset-error' : invalidClientTime } ]">
            <input type="text" class="time" v-mask="'##:##'" v-model="clientTime" placeholder="hh:mm"
                   @blur="checkClientTime">
            <span v-if="invalidClientTime" class="error-text">
              Введённое время меньше минимального ( {{this.currentService.category.minDuration}}ч ) для выбранной категории
            </span>
          </fieldset>
        </div>
        <div class="fieldset">
          <label class="fieldset-title">Тип оплаты</label>
          <fieldset>
            <select v-if="isNew" v-model="newTruckingService.paymentType">
              <option disabled :value="null">-- Выбрать --</option>
              <option :value="0">Часовая</option>
              <option :value="1">Часовая + километраж</option>
            </select>
            <select v-else v-model="truckingService.paymentType">
              <option disabled :value="null">-- Выбрать --</option>
              <option :value="0">Часовая</option>
              <option :value="1">Часовая + километраж</option>
            </select>
          </fieldset>
        </div>
        <div class="fieldset distance">
          <label class="fieldset-title">Расстояние</label>
          <fieldset><input type="number" v-model="manualDistanceVal" min="0"></fieldset>
          <div class="distance-auto"><span>~</span> {{ autoDistanceVal }} <span class="km">км</span></div>
        </div>
      </div>
    </div>
    <div class="title">Адреса:</div>
    <div class="address-section">
      <div class="selected-address-form" v-show="truckingServiceAddresses.length > 0">
        <div class="fieldset">
          <draggable v-model="truckingServiceAddresses">
            <div class="address" v-for="address in truckingServiceAddresses">
              <fieldset class="address-fieldset">
                <input type="text" :value="displayAddress(address)" readonly>
              </fieldset>
              <span class="move-button" title="Переместить"><img src="../image/move.svg"></span>
            </div>
          </draggable>
        </div>
      </div>
      <div class="fieldset select-address-button">
        <div class="add-address" @click="showAddressesFromOrder = true"><span
          class="icon">+</span>Выбрать адреса
        </div>
      </div>
      <div class="select-address-form" v-show="showAddressesFromOrder">
        <div class="fieldset">
          <div class="address" v-for="(address, index) in addressesFromOrder">
            <fieldset class="address-fieldset">
              <input type="text" :value="displayAddress(address)" readonly>
            </fieldset>
            <label class="checkbox-label"><input type="checkbox" @change="addOrRemoveAddress(index, $event)"
                                                 v-model="checkboxesForAddressesFromOrder[index]">выбрать</label>
          </div>
        </div>
        <div class="buttons">
          <button type="button" @click="showAddressesFromOrder = false">Готово</button>
        </div>
      </div>
    </div>
    <div class="buttons">
      <button type="button" class="save-button" @click="saveChanges">Сохранить</button>
    </div>
  </div>
</template>
<script>
  import api from '@/api'
  import draggable from 'vuedraggable'
  import Timepicker from 'vue2-timepicker'
  import utils from '@/utils'
  import {mask} from 'vue-the-mask'
  import AlertWindow from '@/components/AlertWindow.vue'

  export default {
  name: 'TruckingService',
  props: ['isVisible', 'index', 'isNew', 'count', 'addressesFromOrder', 'orderDateTime'],

  components: {
    Timepicker,
    draggable,
    AlertWindow
  },

  directives: { mask },

  data () {
    return {
      newTruckingService: {
        type: 'OrderToTrucking',
        pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToTrucking',
        category: null,
        paymentType: null,
        clientTime: null,
        predictionTime: null,
        distance: 0,
        date: 0
      },

      truckingService: {
        category: null,
        paymentType: null,
        clientTime: null,
        predictionTime: null,
        distance: 0,
        date: 0
      },

      manualDistanceVal: null,
      manualDistanceInitialized: false,
      autoDistanceVal: 0,
      truckingCategories: [],
      truckingServiceAddresses: [],
      showAddressesFromOrder: false,
      checkboxesForAddressesFromOrder: []
    }
  },

  computed: {
    distanceSummary() {
      let distanceIsPresent = Boolean(this.manualDistanceVal);
      if (distanceIsPresent) {
        return parseFloat(this.manualDistanceVal);
      }
      return this.autoDistanceVal;
    },

    currentService: {
      get () {
        return this.isNew
          ? this.newTruckingService
          : this.truckingService
      },

      set (service) {
        if (this.isNew) {
          this.newTruckingService = service
        } else {
          this.truckingService = service
        }
      }
    },

    time: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone(this.currentService.date)
      },

      set (value) {
        if (value.length == 5) {
          let date = new Date(this.currentService.date)
          date.setHours(0, 0, 0, 0)
          this.currentService.date = new Date(date.getTime() + utils.getLongFromFormattedTimeString(value)).getTime()
        }
      }
    },

    clientTime: {
      get () {
        return utils.getFormattedTimeStringFromLongWithoutTimezone((new Date()).setHours(0, 0, 0, 0) + (this.currentService.clientTime))
      },

      set (value) {
        if (value.length === 5) { this.currentService.clientTime = utils.getLongFromFormattedTimeString(value) }
      }
    },

    invalidClientTime: {
      get () {
        return this.currentService.category &&
            this.currentService.clientTime < this.currentService.category.minDuration * 3600000
      }
    },
    truckingServiceAddressesCoords () {
      return this.truckingServiceAddresses.map((address) => utils.getCoordsStringOfAddress(address))
    }
  },

  watch: {
    isVisible (val) {
      if (val) {
        this.manualDistanceInitialized = false;
        if (!this.isNew) {
          this.truckingService = Object.assign({}, this.$store.getters.groupedServices[this.index][0])

          this.truckingServiceAddresses = []
          if (this.truckingService.addresses != null) {
            this.truckingServiceAddresses.push.apply(this.truckingServiceAddresses, this.truckingService.addresses)
          }

          this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()

          this.manualDistanceVal = this.truckingService.distance;
        } else {
          this.newTruckingService = {
            type: 'OrderToTrucking',
            pathToClass: 'ru.itbrick.shustrikoffcrm.beans.OrderToTrucking',
            category: this.truckingCategories[0],
            paymentType: 0,
            clientTime: null,
            predictionTime: null,
            distance: 0,
            date: this.orderDateTime
          }
          this.newTruckingService.clientTime = this.newTruckingService.category.minDuration * 3600000

          if (this.$store.getters.groupedServices.length > 0) {
            let mainServices = this.$store.getters.groupedServices.filter(gs => gs[0].type != 'OrderToAdditional')
            if (mainServices.length > 0) {
              let previousService = mainServices[mainServices.length - 1][0]

              if (previousService.clientTime) {
                if(previousService.clientTime >= this.newTruckingService.clientTime && previousService.clientTime !== 24 * 60 * 60 * 1000) {
                  this.newTruckingService.clientTime = previousService.clientTime
                }
              }
              if (previousService.addresses && previousService.addresses.length > 0 && previousService.type != 'OrderToPetrol') {
                this.newTruckingService.addresses = previousService.addresses
                  .filter(address => address.lat != null && address.lng != null)
                  .map(address => Object.assign({}, address))
              }
            }
          }

          this.truckingServiceAddresses = this.newTruckingService.addresses
            ? this.newTruckingService.addresses : []
          this.checkboxesForAddressesFromOrder = this.fillAddressesFromOrderCheckboxes()
        }
      }
      this.showAddressesFromOrder = false
    },

    async truckingServiceAddresses(addresses) {
      let distance;
      if (!this.truckingServiceAddresses || this.truckingServiceAddresses.length == 0) {
        distance = 0;
      } else {
        distance = await this.$store.dispatch('calculateDistanceForServiceWithOwnDistance', addresses);
      }
      this.autoDistanceVal = distance;
      if (this.manualDistanceInitialized) {
        this.manualDistanceVal = distance;
      } else {
        this.manualDistanceInitialized = true;
      }
    }
  },

  mounted () {
    api
      .getTruckingCategories()
      .then(truckingCategories => {
        if (truckingCategories) {
          this.truckingCategories = []
          this.truckingCategories = truckingCategories
        }
      })
  },

  methods: {
    calculateAutoDistance () {

    },

    displayAddress (address) {
      if (!address || !address.place)
        return '';
      return utils.getSmallAddressFromFull(address.place)
          + (address.comment ? (' ' + address.comment) : '');
    },

    saveChanges () {
      if (this.truckingServiceAddresses.length === 0) {
        this.$refs.alertWindow.show('Ошибка', 'В услуге не выбран ни один адрес', false)
        return false
      }
      let promise
      if (this.isNew) {
        promise = this.addNewService()
      } else { promise = this.updateService() }
      this.$store.commit('addNewGroupedServicesPromise', promise)
      this.clearAddresses()
      this.$emit('close-window', false)
    },

    clearAddresses () {
      this.truckingServiceAddresses = []
      this.checkboxesForAddressesFromOrder = []
    },

    updateService () {
      // при коммите в store index из property является undefined
      let index = this.index
      let count = this.count

      let addresses = this.truckingServiceAddresses.map((item, i) => {
        item.orderNum = i
        return item
      })

      let serviceData = {
        addresses: addresses,
        category: this.truckingService.category,
        paymentType: this.truckingService.paymentType,
        date: this.truckingService.date,
        clientTime: this.truckingService.clientTime,
        predictionTime: this.truckingService.predictionTime,
        distance: this.distanceSummary
      }

      return new Promise(resolve => {
        utils.spotRegionAndDistrictByAddresses(this.truckingServiceAddresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(serviceData, regionDistrictData)

            this.$store.dispatch('updateGroupedServiceByIndex', {
              index: index,
              count: count,
              serviceData: serviceData
            }).then(() => resolve())
          })
      })
    },

    addNewService () {
      return new Promise(resolve => {
        this.newTruckingService.addresses = this.truckingServiceAddresses.map((item, i) => {
          item.id = 0
          item.orderNum = i
          return item
        })
        this.newTruckingService.distance = this.autoDistanceVal

        utils.spotRegionAndDistrictByAddresses(this.$store.getters.addresses, this.$store.getters.regions, this.$store.getters.districts)
          .then(regionDistrictData => {
            Object.assign(this.newTruckingService, regionDistrictData)

            let groupedService = []
            for (let i = 0; i < this.count; i++) { groupedService.push(Object.assign({}, this.newTruckingService)) }

            this.$store.dispatch('addNewGroupedService', groupedService).then(() => resolve())
          })
      })
    },

    onCategoryChange () {
      this.newTruckingService.clientTime = this.currentService.category.minDuration * 3600000
    },

    checkClientTime ($event) {
      if ($event.target.value > 23) {
        this.currentService.clientTime = 82800000
      }
    },

    serviceAddressesHaveAddressAlready (addressFromOrder) {
      let addressFormOrderCoords = utils.getCoordsStringOfAddress(addressFromOrder)
      return this.truckingServiceAddressesCoords.indexOf(addressFormOrderCoords) != -1
    },

    addOrRemoveAddress (index, e) {
      let tmpAddress = Object.assign({}, this.addressesFromOrder[index]);

      if (e.target.checked) {
        this.truckingServiceAddresses.push(tmpAddress)
      } else {
        let addressFormOrderCoords = utils.getCoordsStringOfAddress(tmpAddress)
        let removeAddressIndex = this.truckingServiceAddressesCoords.indexOf(addressFormOrderCoords)
        if (removeAddressIndex > -1) {
          this.truckingServiceAddresses.splice(removeAddressIndex, 1)
        }
      }
    },

    fillAddressesFromOrderCheckboxes () {
      return this.addressesFromOrder.map(addressFromOrder => {
        return this.serviceAddressesHaveAddressAlready(addressFromOrder)
      })
    }
  }
}
</script>
